import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Box, Stack, keyframes } from '@chakra-ui/react';

import { Text } from '@outdoorly/text';
import { usePricing } from '@outdoorly/util';

export const ProductPrice = (props) => {
  const { product, definiteCurrentVariant, isDesktop } = props;

  const productPricing = usePricing(product);

  // ---- ANIMATION ----
  const [spring, setSpring] = useState(false);
  const forwardAnimation = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.25);
  }`;

  const backwardsAnimation = keyframes`
  from {
    transform: scale(1.25);
  }
  to {
    transform: scale(1);
  }`;

  const variantPricing = usePricing(definiteCurrentVariant);

  const { undiscountedPrice, discountedPrice } = definiteCurrentVariant
    ? variantPricing
    : productPricing;
  const hasDefiniteCurrentVariant = !!definiteCurrentVariant;

  useEffect(() => {
    if (hasDefiniteCurrentVariant && isDesktop) {
      setSpring(true);
      setTimeout(() => setSpring(false), 200);
    }
  }, [hasDefiniteCurrentVariant, undiscountedPrice, discountedPrice]);

  return (
    <Box ml={[4, 4, 4, 0]} mt={[1, 1, 1, 0]} mb={[3, 3, 3, 0]}>
      <Box
        float="left"
        animation={
          spring
            ? `${forwardAnimation} 100ms linear forwards`
            : `${backwardsAnimation} 100ms linear forwards`
        }
      >
        {discountedPrice ? (
          <Stack direction="row" spacing={1}>
            <Text size="lg" fontWeight="500" color="scheme.priceDiscounted">
              {discountedPrice}
            </Text>
            <Text
              size="sm"
              textDecoration="line-through"
              color="scheme.priceRegular"
            >
              {undiscountedPrice}
            </Text>
          </Stack>
        ) : (
          <Text size="lg" fontWeight="500" color="scheme.priceRegular">
            {undiscountedPrice}
          </Text>
        )}
      </Box>
    </Box>
  );
};

ProductPrice.propTypes = {
  definiteCurrentVariant: PropTypes.object,
  isDesktop: PropTypes.bool,
  product: PropTypes.object,
};
